import { AfterViewInit } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import MarkerClusterer from '@googlemaps/markerclustererplus';
import { MetaService } from '@ngx-meta/core';
import { ApiService } from '../../../app/shared/_services/api.service';

declare var google: any;

@Component({
  selector: 'app-installatori',
  templateUrl: './installatori.component.html',
  styles: []
})
export class InstallatoriComponent implements OnInit, AfterViewInit {

  constructor(private route: ActivatedRoute, private meta: MetaService) { }

  installatori = [];

  ricercaLuogo = '';

  map;

  ngOnInit() {
    this.installatori = this.route.snapshot.data.InstallatoriResolver;
    this.meta.setTag('description', 'INSTALLATORI_DESCRIPTION');
    this.meta.setTitle('INSTALLATORI_TITLE');
  }

  ngAfterViewInit(): void {
    this.initMap();
  }

  cercaLuogo() {
    // this.api.googleMapsPlacesSearch(this.ricercaLuogo).subscribe(res => console.log(res));

    const request = {
      query: this.ricercaLuogo,
      fields: ['name', 'geometry'],
    };

    const service = new google.maps.places.PlacesService(this.map);

    service.findPlaceFromQuery(request, (results, status) => {
      if (status === google.maps.places.PlacesServiceStatus.OK) {
        this.map.setCenter(results[0].geometry.location);
        this.map.setZoom(10);
      }
    });

  }


  initMap(): void {

    this.map = new google.maps.Map( document.getElementById('map') as HTMLElement, {} );

    const bounds = new google.maps.LatLngBounds();
    const infowindow = new google.maps.InfoWindow();

    const markers = this.installatori.filter(i => i.geolocalizzazione).map(i => {
      const marker = new google.maps.Marker({
        position: { lat: Number.parseFloat(i.geolocalizzazione.latitudine), lng: Number.parseFloat(i.geolocalizzazione.longitudine) },
        label: '',
      });
      bounds.extend(marker.position);

      google.maps.event.addListener(marker, 'click', ((m, index) => {
        return () => {
          infowindow.setContent(`<b>${i.ragioneSociale}</b><br>${i.geolocalizzazione.indirizzo}, ${i.geolocalizzazione.civico}, ${i.geolocalizzazione.cap} ${i.geolocalizzazione.citta} ${i.geolocalizzazione.provincia}`);
          infowindow.open(this.map, m);
        }
      })(marker, i));

      return marker;
    });

    this.map.fitBounds(bounds);
    const x = new MarkerClusterer(this.map, markers, { imagePath: 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m', });
  }



}


